import { Colors, SnackbarBackground } from './types';

export const getSnackbarBackground = (color: string) => {
  switch (color) {
    case Colors.GREEN:
      return SnackbarBackground.GREEN;
    case Colors.YELLOW:
      return SnackbarBackground.YELLOW;
    case Colors.ORANGE:
      return SnackbarBackground.ORANGE;
    case Colors.RED:
      return SnackbarBackground.RED;
    default:
      return SnackbarBackground.GREEN;
  }
};
